import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetSimXReleaseTagsRequest } from '../models/requests/get-simx-release-tags-request.model';
import { GetSimXReleaseTagsResponse } from '../models/responses/get-simx-release-tags-response.model';
import { DataService } from './data.service';

@Injectable({ providedIn: 'root' })
export class ReleaseTagDataService {
  private readonly _dataService = inject(DataService);
  private readonly _http = inject(HttpClient);

  getReleaseTags(
    request: GetSimXReleaseTagsRequest = {},
  ): Observable<GetSimXReleaseTagsResponse> {
    const url = this._dataService.releaseTagsUrl();
    return this._http.post<GetSimXReleaseTagsResponse>(url, request);
  }
}
